'use strict';

var React = require('react'),
    { values } = require('underscore'),
    PageControls = require('../molecules/PageControls'),
    Button = require('../atoms/Button'),
    Link = require('../atoms/Link'),
    AlertActionCreators = require('../actions/AlertActionCreators'),
    AlertTypes = require('../constants/AlertTypes'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    createAnalyticsContextMixin = require('../mixins/createAnalyticsContextMixin'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    AnalyticsSources = require('../constants/AnalyticsSources'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Icon = require('../atoms/Icon'),
    ServiceTypes = require('../constants/ServiceTypes'),
    Share = require('../molecules/Share'),
    ImageActionCreators = require('../actions/ImageActionCreators'),
    ShareActionCreators = require('../actions/ShareActionCreators'),
    ImageStore = require('../stores/ImageStore'),
    StampStore = require('../stores/StampStore'),
    UserStore = require('../stores/UserStore'),
    ImageAttribution = require('../molecules/ImageAttribution'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    SectionTypes = require('../constants/SectionTypes'),
    shallowEqual = require('react/lib/shallowEqual'),
    { PropTypes } = React;

var ImagePageControls = React.createClass({
  mixins: [
    ClassNameMixin,
    PureRenderMixin,
    BackColorMixin,
    createAnalyticsContextMixin(AnalyticsSources.STAMP_PAGE_CONTROLS),
    createStoreMixin(StampStore, ImageStore, UserStore)
  ],

  propTypes: {
    stampId: PropTypes.number,
    imageUuid: PropTypes.string.isRequired,
    sectionType: PropTypes.oneOf(values(SectionTypes)).isRequired
  },

  getStateFromStores(props) {
    var image = ImageStore.getInStamp(props.imageUuid, props.stampId),
        sourceImage,
        sourceStamp,
        sourceUser,
        stamp;

    if (image) {
      sourceImage = ImageStore.getSourceImage(image) || image;
      sourceStamp = ImageStore.getSourceStamp(image, props.stampId);
      sourceUser = UserStore.get(sourceStamp.user);
      stamp = StampStore.get(props.stampId);
    }

    return { image, sourceImage, sourceStamp, sourceUser, stamp };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  canRenderCollectButton() {
    var { sourceImage, sourceStamp, stamp } = this.state;
    if (!sourceImage || !sourceStamp || !stamp) {
      return false;
    }

    return true;
  },

  canRenderAttribution() {
    var { sourceStamp, sourceImage, stamp } = this.state;
    if (!sourceImage || !sourceStamp || !stamp) {
      return false;
    }

    return true;
  },

  render() {
    var canRenderCollectButton = this.canRenderCollectButton(),
        canRenderAttribution = this.canRenderAttribution(),
        color;

    if (this.state.image) {
      switch (this.props.sectionType) {
      case SectionTypes.COVER:
      case SectionTypes.POSTER:
        color = this.getTextColor(this.state.image.colors.bottom);
        break;
      default:
        color = 'light';
      }
    }

    return (
      <PageControls color={color}>
        {canRenderCollectButton &&
          <PageControls.Container>
            {this.renderCollectButton()}
          </PageControls.Container>
        }

        {canRenderCollectButton && canRenderAttribution &&
          <PageControls.Separator />
        }

        <PageControls.Container fill>
          {canRenderAttribution &&
            this.renderAttribution()
          }
        </PageControls.Container>

        <PageControls.Container>
          <Share services={[ServiceTypes.PINTEREST, ServiceTypes.TUMBLR]}
                 context='PageControls'
                 onShareClick={this.handleShareClick}
                 color='black'
                 size='medium'
                 iconSize='small'
                 overlay />
        </PageControls.Container>
      </PageControls>
    );
  },

  renderCollectButton() {
    return ([
      <Button key='save'
              color='green'
              context='PageControls'
              onClick={this.handleSaveClick}
              size='medium'
              fill
              round>
        <Icon size='small'
              name='collect'
              mode='stroke' />
      </Button>,
      <div key='what'
           className='PageControls-info PageControls-info--toRight'>
        <Link onClick={this.handleWhatsThisClick}
              opaque>
          What’s this?
        </Link>
      </div>
    ]);
  },

  renderAttribution() {
    if (!this.canRenderAttribution()) {
      return;
    }

    var { sourceStamp, sourceImage, sourceUser, stamp } = this.state;
    return (
      <ImageAttribution sourceStamp={sourceStamp}
                        sourceImage={sourceImage}
                        sourceUser={sourceUser}
                        stamp={stamp}
                        context='PageControls' />
    );
  },

  handleSaveClick() {
    var { sourceImage, sourceStamp } = this.state;
    ImageActionCreators.addToGrabbag(sourceImage.uuid, sourceStamp.id);
  },

  handleShareClick(service) {
    var { stampId } = this.props,
        { image } = this.state;

    if (!stampId || !image) {
      return;
    }

    ShareActionCreators.shareStamp({
      stampId: stampId,
      imageUrl: image.url,
      service: service,
      source: AnalyticsSources.LIGHTBOX
    });
  },

  handleWhatsThisClick() {
    AlertActionCreators.showAlert(AlertTypes.STAMP_SAVE_IMAGE_HELP);
  }
});

module.exports = ImagePageControls;



/** WEBPACK FOOTER **
 ** ./pageControls/ImagePageControls.jsx
 **/